import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  FormControl,
  FormLabel,
  Select,
  SimpleGrid,
  useColorModeValue
} from "@chakra-ui/react";
import axios from "axios";
import JoditEditor from "jodit-react";
import { ClientClassificationType } from "models/client_classification_type";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { EntregavelItem } from "models/entregavel_itens_type";
import { OrderCategory } from "models/order_category";
import { PessoaType } from "models/person_type";
import { ProductType } from "models/product_type";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import useNewProduct from "views/admin/config/newproduct/hooks/useNewProduct";
import formatNumber from "../hooks/formatNumber";

interface IOrderLetter {
  carta: string;
  changeCarta: (carta: string) => void;
  numeroProposta: string;
  cliente: PessoaType | undefined;
  agencia: PessoaType | undefined;
  projeto: string;
  showAgenciaInput: boolean;
  contatoAgencia: string;
  contatoCliente: string;
  totalOrder: number;
  validade: Date;
  itens: OrderCategory[] | undefined;
  descricao: string;
  footNote: string;
  selectedEntregaveis: EntregavelItem[];
  condicaoPagamento: CondicaoPagamento | undefined;
  entregavel: ClientClassificationType[];
}

const OrderLetter = ({
  carta,
  changeCarta,
  numeroProposta,
  cliente,
  agencia,
  projeto,
  showAgenciaInput,
  contatoAgencia,
  contatoCliente,
  totalOrder,
  validade,
  itens,
  descricao,
  footNote,
  condicaoPagamento,
  selectedEntregaveis,
  entregavel,
}: IOrderLetter) => {
  const editor = useRef(null);
  const [showItens, setShowItens] = useState(true);
  const [produtos, setProdutos] = useState<ProductType[]>([]);

  const changeOptions = (value: string) => {
    if (value === "1") {
      setShowItens(true);
    }
    if (value === "2") {
      setShowItens(false);
    }
  };
  const loadData = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/produto/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setProdutos(response.data);
    }
  };

  const {
list
  } = useNewProduct();

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const content = `
  <style type="text/css">
  body{
  background:url("https://s3.amazonaws.com/arquivos-jobb/arquivos/adoreproducoes/images/bg-broders.jpg");
  background-image-resize: 1;
  font-family:arial;
  font-size:13px;
  }
</style>
<table border="0" cellpadding="2" cellspacing="0" width="760">
  <tbody>
     <tr>
        <td height="303" valign="top">
           <br>
           <table border="0" cellpadding="2" cellspacing="0" width="760">
              <tbody>
                 <tr>
                    <td width="380"><img alt="" src="https://s3.amazonaws.com/arquivos-jobb/arquivos/adoreproducoes/images/top-broders.jpg" style="width: 700px; height: 87px;"></td>
                 </tr>
                 <tr>
                    <td width="380">&nbsp;<br></td>
                 </tr>
              </tbody>
           </table>
           <table border="0" cellpadding="4" cellspacing="5" width="755">
              <tbody>
                 <tr>
                    <td><strong style="text-align: -webkit-center;">Proposta Nº:</strong><span style="text-align: -webkit-center;">&nbsp;0000${numeroProposta}</span></td>
                 </tr>
                 <tr>
                    <td><strong>Cliente:</strong> ${
                      cliente?.nome === undefined ? "" : cliente?.nome
                    }</td>
                 </tr>
                 <tr>
                    <td><strong>Projeto:</strong> ${projeto}</td>
                 </tr>
                 <tr style="display:${(showAgenciaInput === false ? 'none' : 'block' )}">
                    <td><strong>Agência:</strong>${
                      agencia?.nome === undefined ? "" : agencia?.nome
                    }</td>
                 </tr>
                 <tr style="display:${(showAgenciaInput === false ? 'none' : 'block' )}">
                    <td><strong>A/C:</strong>&nbsp;${contatoAgencia}</td>
                 </tr>
                 <tr>
                    <td>

                    <p style="font-size: 9pt; text-align: justify;"><strong>Entregáveis :</strong></p><br/>

                      ${selectedEntregaveis?.map(
                        (et) =>
                          `<p style="font-size:9pt;font-style:italic">${
                            et.quantidade < 10
                              ? "0" + et.quantidade
                              : et.quantidade
                          } - ${
                            entregavel?.find((el) => el.id === et.entregavelId)
                              ?.nome
                          }</p>`
                      )}
                    </td>
                 </tr>
              </tbody>
           </table>
           ${itens.map(
             (item) =>
               `<p style="font-size: 9pt; text-align: justify;"><strong>${
                 item?.descricao
               } :</strong></p>
                       <table border="0" cellpadding="2" cellspacing="0" width="760">
                       <tbody>
                          ${
                            showItens === true
                              ? item?.OrcamentoItem?.map(
                                  (val) => `<tr>
                                  <td style="font-size: 9pt; text-align: justify; margin-left : 24px"> - ${
                                    produtos.find(
                                      (pr) => pr.id === val?.produtoId
                                    )?.nome
                                  }</td>
                                </tr>`
                                )
                              : ""
                          }
                          ${
                            showItens === true
                              ? item?.OrcamentoProduto?.map(
                                  (val) => `<tr>
                                  <td style="font-size: 9pt; text-align: justify; margin-left : 24px"> - ${
                                    list.find(
                                      (pr) => pr.id === val?.novoProdutoId
                                    )?.nome
                                  }</td>
                                </tr>`
                                )
                              : ""
                          }
                         
                       </tbody>
                    </table>`
           )}
           <hr style="border:3px #000">
           <table border="1" cellpadding="5" cellspacing="5" style="border:2px #999 dashed" width="760">
              <tbody>
                 <tr>
                    <td align="center" width="182"><strong>TOTAL:</strong></td>
                    <td align="left" width="578">${formatNumber(
                      totalOrder
                    )}</td>
                 </tr>
              </tbody>
           </table>
           <table border="0" cellpadding="5" cellspacing="5" width="760">
              <tbody>
                 <tr>
                    <td align="center" width="182" style="width: 9.60526%;">
                       <p>&nbsp;<br></p>
                       <br>
                    </td>
                    <td align="right" width="578" style="text-align: left; width: 90.2632%;">
                       <style type="text/css">
                          p.p1 {margin: 0.0px 0.0px 0.0px 0.0px; line-height: 15.0px; font: 13.0px Arial; color: #333333; background-color: #ffffff}
                          span.s1 {font-kerning: none}
                       </style>
                       <p class="p1" style=""><span class="s1"><strong>Emissão&nbsp;de NF:</strong>&nbsp;100% no ato da aprovação</span></p>
                       <p class="p1" style=""><span class="s1"><strong>Condições de pagamento</strong>: ${
                         condicaoPagamento?.nome
                       }</span></p>
                       <strong>Validade da proposta:</strong>&nbsp;${moment(
                         validade
                       ).format("DD/MM/YYYY")}
                    </td>
                 </tr>
              </tbody>
           </table>
           ${descricao}
          ${footNote}
          <table border="0" cellpadding="2" cellspacing="0" width="760">
            <tbody>
                <tr>
                    <td style="font-size: 9pt; text-align: justify;"><strong>Termos e Condições:</strong><br><strong style="font-weight:normal;" id="docs-internal-guid-175d7f93-7fff-96c4-c23d-f4518231fb92"><span style="font-size:9pt;font-family:Arial;color:#333333;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">Qualquer serviço de produção ou pós-produção não especificados nesta proposta deverão ser orçados a parte. Para autorização de produção é necessária a aceitação dos termos da presente proposta que será formalizada através da assinatura do Pedido de Compra ou Contrato de Prestação de Serviços para todos os efeitos legais.</span></strong><br></td>
                </tr>
            </tbody>
          </table>`;
  useEffect(() => {
    loadData();
  }, []);
  return (
    <AccordionItem>
      <h2>
        <AccordionButton>
          <Box flex="1" textAlign="left" color={"#422AFB"} fontWeight={"bold"}>
            Carta Apresentação
          </Box>
          <AccordionIcon color={"#422AFB"} />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        <SimpleGrid columns={3} spacing={4} mb={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Modelos de Orçamento
            </FormLabel>

            <Select
              size="md"
              onChange={(e) => {
                changeOptions(e.target.value);
              }}
            >
              <option value="1">COMPLETO</option>
              <option value="2">SIMPLES</option>
            </Select>
          </FormControl>
        </SimpleGrid>

        <JoditEditor
          ref={editor}
          value={content}
          config={{
            buttons: [
              "source",
              "|",
              "bold",
              "strikethrough",
              "underline",
              "italic",
              "|",
              "ul",
              "ol",
              "|",
              "outdent",
              "indent",
              "|",
              "font",
              "fontsize",
              "brush",
              "paragraph",
              "|",
              "image",
              "video",
              "table",
              "link",
              "|",
              "align",
              "undo",
              "redo",
              "|",
              "hr",
              "eraser",
              "copyformat",
              "|",
              "symbol",
              "fullsize",
              "print",
              "about",
            ],
            buttonsXS: [
              "bold",
              "image",
              "|",
              "brush",
              "paragraph",
              "|",
              "align",
              "|",
              "undo",
              "redo",
              "|",
              "eraser",
              "dots",
            ],
            readonly: false,
          }}
          onBlur={(newContent) => {
            changeCarta(newContent);
          }}
        />
      </AccordionPanel>
    </AccordionItem>
  );
};
export default OrderLetter;
